import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import ErrorMessage from '../Errors/ErrorMessage';

const Select = ({
  title,
  labelClass,
  name,
  className,
  options = [],
  formikOnChange = true,
  optionLabel = 'label',
  optionValue = 'value',
  multiLabel = false,
  onChange = () => {},
  serverError,
  disabled = false,
  selectedElementExists = true,
}) => {
  const { errors, setFieldValue, values } = useFormikContext();
  return (
    <div className='form-group'>
      <label
        className={`f-13 text-left d-flex flex-row justify-content-start ${labelClass}`}
      >
        {title}
      </label>
      <select
        disabled={disabled}
        name={name}
        className={`form-control ${className}`}
        value={values[name]}
        onChange={(e) => {
          if (!disabled) {
            if (formikOnChange) {
              setFieldValue(name, e.target.value, true);
            }
            onChange(e.target.value);
          }
        }}
      >
        {selectedElementExists && (
          <option value={'null'}>انتخاب {title}</option>
        )}

        {options.length > 0 && (
          <>
            {options?.map((item) => (
              <option key={item[optionValue]} value={item[optionValue]}>
                {multiLabel ? optionLabel(item) : item[optionLabel]}
              </option>
            ))}
          </>
        )}
      </select>
      <ErrorMessage error={errors[name] ? errors[name] : serverError} />
    </div>
  );
};
Text.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  options: PropTypes.array.isRequired,
  optionLabel: PropTypes.any,
  optionValue: PropTypes.any,
  multiLabel: PropTypes.bool,
  serverError: PropTypes.any,
  onChange: PropTypes.func,
  labelClass: PropTypes.string,
  disabled: PropTypes.bool,
  selectedElementExists: PropTypes.bool,
};
export default Select;
